var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import styles from './sds-dropdown-button.lit.scss';
import { SdsButtonDropdownBase } from '../_sds-button-dropdown-base.lit';
import { sdsCustomElement } from '../../utilities/custom-components';
/**
 * Control that represents button dropdown.
 */
let SdsButtonDropdown = (() => {
    var _SdsButtonDropdown_secondaryLabel_accessor_storage, _SdsButtonDropdown_noArrow_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-button-dropdown')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsButtonDropdownBase;
    let _secondaryLabel_decorators;
    let _secondaryLabel_initializers = [];
    let _secondaryLabel_extraInitializers = [];
    let _noArrow_decorators;
    let _noArrow_initializers = [];
    let _noArrow_extraInitializers = [];
    var SdsButtonDropdown = _classThis = class extends _classSuper {
        /**
         * A secondary label displayed under the main label.
         * This attribute is used only for main navigation dropdowns.
         *
         * @attr {string} secondary-label - The secondary text to display on the button.
         * @default ''
         */
        get secondaryLabel() { return __classPrivateFieldGet(this, _SdsButtonDropdown_secondaryLabel_accessor_storage, "f"); }
        set secondaryLabel(value) { __classPrivateFieldSet(this, _SdsButtonDropdown_secondaryLabel_accessor_storage, value, "f"); }
        /**
         * Hides the arrow icon on the dropdown button.
         *
         * @attr {boolean} no-arrow - If true, the arrow icon will not be displayed.
         * @default false
         */
        get noArrow() { return __classPrivateFieldGet(this, _SdsButtonDropdown_noArrow_accessor_storage, "f"); }
        set noArrow(value) { __classPrivateFieldSet(this, _SdsButtonDropdown_noArrow_accessor_storage, value, "f"); }
        render() {
            return html `<button
                id="trigger"
                part="sds-button"
                class="${this.getClasses()}"
                @click="${this.toggleContextMenu}"
                @keydown="${this.handleKeyDown}"
                .disabled="${this.disabled}"
                type="button"
                aria-haspopup="true"
                aria-expanded="${this.opened}"
                aria-disabled="${this.disabled ? 'true' : 'false'}"
                aria-label="${this.label ? this.label : this.iconName}"
            >
                ${this.renderIcon()} ${this.renderButtonContent()} ${this.renderArrowIcon()}
                ${this.renderBadge()}
            </button>

            <div id="dropdown-status" class="sr-only" aria-live="polite"></div>

            <sds-context-menu
                position="below"
                ?hidden="${!this.opened}"
                @menu-closed="${this.handleMenuClosed}"
            >
                <slot></slot>
            </sds-context-menu>`;
        }
        renderIcon() {
            if (this.icon) {
                return html `<sds-icon
                size="${this._iconSize}"
                name="${this.icon}"
                aria-hidden="true"
            ></sds-icon>`;
            }
        }
        renderButtonContent() {
            if (this.secondaryLabel) {
                return html ` <div class="sds-button__content">
                <div class="sds-button__label">${this.label}</div>
                <div class="sds-button__secondary-label">${this.secondaryLabel}</div>
            </div>`;
            }
            else {
                return html `${this.label}`;
            }
        }
        renderArrowIcon() {
            if (!this.noArrow) {
                let _iconSize;
                if (this._size === 'lg') {
                    _iconSize = 24;
                }
                else if (!this.label && this.type === 'ghost') {
                    _iconSize = 8;
                }
                else {
                    _iconSize = 16;
                }
                return html `<sds-icon
                size="${_iconSize}"
                name="${this.opened ? 'arrow_up_small' : 'arrow_down_small'}"
                aria-hidden="true"
            ></sds-icon>`;
            }
        }
        renderBadge() {
            if (this.badge) {
                return html `
                <div
                    class="sds-button__badge"
                    aria-hidden="${this.badge ? 'false' : 'true'}"
                    aria-label="${this.badge}"
                >
                    ${this.badge}
                </div>
            `;
            }
        }
        constructor() {
            super(...arguments);
            _SdsButtonDropdown_secondaryLabel_accessor_storage.set(this, __runInitializers(this, _secondaryLabel_initializers, void 0));
            _SdsButtonDropdown_noArrow_accessor_storage.set(this, (__runInitializers(this, _secondaryLabel_extraInitializers), __runInitializers(this, _noArrow_initializers, false)));
            __runInitializers(this, _noArrow_extraInitializers);
        }
    };
    _SdsButtonDropdown_secondaryLabel_accessor_storage = new WeakMap();
    _SdsButtonDropdown_noArrow_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsButtonDropdown");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _secondaryLabel_decorators = [property({ type: String, attribute: 'secondary-label' })];
        _noArrow_decorators = [property({ type: Boolean, attribute: 'no-arrow' })];
        __esDecorate(_classThis, null, _secondaryLabel_decorators, { kind: "accessor", name: "secondaryLabel", static: false, private: false, access: { has: obj => "secondaryLabel" in obj, get: obj => obj.secondaryLabel, set: (obj, value) => { obj.secondaryLabel = value; } }, metadata: _metadata }, _secondaryLabel_initializers, _secondaryLabel_extraInitializers);
        __esDecorate(_classThis, null, _noArrow_decorators, { kind: "accessor", name: "noArrow", static: false, private: false, access: { has: obj => "noArrow" in obj, get: obj => obj.noArrow, set: (obj, value) => { obj.noArrow = value; } }, metadata: _metadata }, _noArrow_initializers, _noArrow_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsButtonDropdown = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsButtonDropdown = _classThis;
})();
export { SdsButtonDropdown };
